var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 24.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#18174a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profit"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,22.13H25v-12a2,2,0,0,0-2-2H21a2,2,0,0,0-2,2v12H17v-9a2,2,0,0,0-2-2H13a2,2,0,0,0-2,2v9H9v-6a2,2,0,0,0-2-2H5a2,2,0,0,0-2,2v6H1a1,1,0,0,0,0,2H27a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3,12.13a1,1,0,0,0,.35-.06L22.06,5.18l-.24.51a1,1,0,1,0,1.81.85l1.28-2.71a1,1,0,0,0-.49-1.33h0L21.71,1.22A1,1,0,0,0,20.86,3l.55.26L2.65,10.19A1,1,0,0,0,3,12.13Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon_4.6d64b2ca8b83d78badb913edb85e97c7.svg";
export { ForwardRef as ReactComponent };